import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext, useDictionary } from "../../../shared";
import { REPORT_ID, SLIDE_NUMBER } from "../constants";
import { dictionaryService } from "../../../dataFlow";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";

import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [calendar] = useParameter<number[]>("@calendar");

  const [sources, setSources] = useParameter<string[]>("@sources");
  const [commodities, setCommodities] = useParameter<number>("@commodities");
  const [commodityDisplay, setCommodityDisplay] = useParameter<number>("@commodities_display");

  const [dictItems] = useDictionary(dictionaryService, "commodities_slide_31_32", undefined, {
    olap_commodity: commodities,
    slide: SLIDE_NUMBER,
  });

  useEffect(() => {
    const historicalSources = dictItems?.filter((e) => e.getValue("comment") === "historical").map((e) => e.getValue("source")) || [];

    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@calendar": calendar,
      "@commodities": commodities,
      "@commodities_display": commodityDisplay,
      "@sources": [...historicalSources, ...(sources || [])] as string[],
    });
  }, [title, subtitle, calendar, commodities, commodityDisplay, sources, dictItems, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setSources(parameters["@sources"].value as string[]);
      setCommodities((parameters["@commodities"].value as string[]).map(Number)[0]);
      setCommodityDisplay((parameters["@commodities_display"].value as string[]).map(Number)[0]);
    },
    [setSources, setCommodities, setCommodityDisplay]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
